import React, { useState } from "react";
import CatScreenDetails from "../components/Category/CatScreenDetails";
import SellerReviews from "../components/SellerReviews/SellerReviews";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Footer from "./Layout/Footer";
import { toNormal } from "../constants";

function DealerAdverts(props) {
  let params = useParams();
  const [adverts, setAdverts] = React.useState([]);
  const [nextPage, setNextPage] = React.useState(null);
  const [loading, setLoading] = useState(true);
  const [total, settotal] = React.useState(0);

  const dealerDisplayName = toNormal(decodeURIComponent(params.dealer_name || ""));

  React.useEffect(() => {
    let link = `https://dashboard.maineautoparts.com/api/dealer-adverts/${params.dealer_id}/${params.dealer_name}`;
    axios.get(link).then((response) => {
      setNextPage(response.data.next_page_url);
      settotal(response.data.total);
      setAdverts(response.data.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [params]);

  return (
    <div>
      <div className="main-container container">
        {/* Breadcrumb */}
        <ul className="breadcrumb">
          <li>
            <Link to="/"><i className="fa fa-home"></i></Link>
          </li>
          <li>
            <Link to="#">{dealerDisplayName}</Link>
          </li>
        </ul>

        {/* Dealer Profile Header */}
        <div className="row" style={{ marginBottom: 24 }}>
          <div className="col-md-12">
            <div style={{
              background: "linear-gradient(135deg, #1D2348 0%, #e06027 100%)",
              borderRadius: 12,
              padding: "32px 28px",
              display: "flex",
              alignItems: "center",
              gap: 20,
              color: "#fff",
            }}>
              {/* Avatar */}
              <div style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 32,
                fontWeight: "bold",
                flexShrink: 0,
                border: "2px solid rgba(255,255,255,0.4)",
              }}>
                {dealerDisplayName.charAt(0).toUpperCase()}
              </div>
              {/* Info */}
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                  <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#fff" }}>
                    {dealerDisplayName}
                  </h1>
                  <span style={{
                    background: "rgba(255,255,255,0.25)",
                    borderRadius: 20,
                    padding: "2px 12px",
                    fontSize: 12,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                  }}>
                    ✓ Verified Dealer
                  </span>
                </div>
                <p style={{ margin: "6px 0 0", fontSize: 14, opacity: 0.85 }}>
                  {loading ? "Loading..." : `${total} product${total !== 1 ? "s" : ""} listed`}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Product Listings */}
        <div className="row">
          <div id="content" className="col-md-12">
            <CatScreenDetails
              ads={adverts}
              category={dealerDisplayName}
              nextPageUrl={nextPage}
              four
              loading={loading}
              small="ads by"
            />
          </div>
        </div>

        {/* Seller Reviews */}
        {params.dealer_id && (
          <div className="row">
            <div className="col-md-12">
              <SellerReviews
                dealerId={params.dealer_id}
                dealerName={dealerDisplayName}
              />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default DealerAdverts;
